// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1b67ae81","455":"3a8075d7","977":"deb697cd"}[chunkId] + ".chunk.js";
};